import I18n from 'i18n-js';
import { func } from 'prop-types';

import ScratchIcon from '~/assets/images/loot-cards/scratch-icon.png';

import styles from './Scratch.module.scss';

function Scratch({ onOpened }) {
  return (
    <div className={styles.scratchCardOverlayContainer}>
      <p className={styles.scratchCardButtonLegend}>
        {I18n.t('RewardCodeView_label_default')}
      </p>
      <div
        className={styles.scratchCardOverlay}
        onClick={onOpened}
      >
        <p>
          {I18n.t('RewardCodeView_scratch_here')}
          <img
            src={ScratchIcon}
            alt="scratch-icon"
          />
        </p>
      </div>
    </div>
  );
}

Scratch.propTypes = {
  onOpened: func,
};

export default Scratch;
